import styled from '@emotion/styled/macro';
import { Variables } from '@enter/core';
import { Field } from 'formik';

export const DialogBody = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 24px 24px;
    gap: 16px;
    width: 100%;
`;

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
`;

export const Label = styled.span`
    font-size: 16px;
    font-weight: 500;
    color: ${Variables.Colors.n70};
`;

export const Description = styled.span`
    font-size: 14px;
    color: ${Variables.Colors.n50};
`;

export const Info = styled.div`
    font-size: 13px;
    color: ${Variables.Colors.n50};
    line-height: 1.4;
    background: ${Variables.Colors.n5};
    border-radius: 4px;
    padding: 8px 12px;
`;

export const FormField = styled(Field)`
    width: 100%;
    display: block;
`;

export const Actions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
`;

export const FileActions = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const FileRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 6px 0;
    border-top: 1px solid ${Variables.Colors.n5};
`;

export const ErrorMessage = styled.span`
    font-size: 13px;
    color: ${Variables.Colors.warning};
`;

